import { render, staticRenderFns } from "./AllPrizes.vue?vue&type=template&id=0681f476&scoped=true&"
import script from "./AllPrizes.vue?vue&type=script&lang=js&"
export * from "./AllPrizes.vue?vue&type=script&lang=js&"
import style0 from "./AllPrizes.vue?vue&type=style&index=0&id=0681f476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0681f476",
  null
  
)

export default component.exports